import React, { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import SuccessImage from 'src/assets/images/success.png'

const RecollectionEmptyStateComponent = () => {
  return (
    <div css={tw`flex flex-col items-center bg-shades-0 rounded-2xl p-6 text-center`}>
      <img src={SuccessImage} alt="" css={tw`h-[176px] w-[224px]`} />
      <Typography variant="h3" css={tw`mt-4`}>
        No action needed
      </Typography>
      <Typography css={tw`mt-2 text-shades-400`}>
        You don&apos;t have any documents that are expired or expiring soon.
      </Typography>
    </div>
  )
}

export const RecollectionEmptyState = memo(RecollectionEmptyStateComponent)
